import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdminPanelService} from '../../../../data/admin-panel.service';
import {MiscSnackBarService} from '../../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {CategoryModifier} from '../../../../../project-calc/data/category-modifier';
import {ModifierField} from '../../../../../project-calc/data/modifier-field';
import {ShortObject} from '../../../../../project-misc/data/project/short-json-object';
import {PricingMiscItem} from '../../../../../project-calc/data/misc-item/pricing-misc-item';
import {PricingMiscItemPreset} from '../../../../../project-calc/data/misc-item/pricing-misc-item-preset';
import {PricingCategory} from '../../../../../project-calc/data/pricing-category';

@Component({
  selector: 'app-modifier-editor-dialog',
  templateUrl: './modifier-editor-dialog.component.html',
  styleUrls: ['./modifier-editor-dialog.component.scss']
})
export class ModifierEditorDialogComponent implements OnInit {
  headerTitle = 'New Modifier';
  footerBtnString = 'Add'

  tempModifier: CategoryModifier;

  loadingSpinner: boolean;
  deleteLoadingSpinner: boolean;

  typeLoading = true;

  categories: PricingCategory[]

  miscList: PricingMiscItem[];

  miscPresetsList: PricingMiscItemPreset[];
  chosenPreset: PricingMiscItemPreset;


  constructor(
    protected dialogRef: MatDialogRef<ModifierEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      modifier: CategoryModifier,
      miscList: PricingMiscItem[],
      categories: PricingCategory[]
      miscPresetsList: PricingMiscItemPreset[]
    }
  ) {
    this.tempModifier = Object.assign({}, this.data.modifier);
    this.categories = this.data.categories;

    this.miscList = this.data.miscList;

    this.miscPresetsList = this.data.miscPresetsList;


    if (this.tempModifier.id) {
      this.headerTitle = 'Edit Modifier';
      this.footerBtnString = 'Save';

      this.chosenPreset = this.miscPresetsList.find(item => item.value === this.tempModifier.preset)
      this.tempModifier.affectingCategory = this.categories.find(shortCat => shortCat.id === this.tempModifier.affectingCategory.id)
      this.tempModifier.owningCategories = this.categories.filter(shortCat => !!this.data.modifier.owningCategories.find(ownCat => ownCat.id === shortCat.id))
    }
  }

  ngOnInit(): void {
    this.typeLoading = false
  }

  saveSub() {
    this.loadingSpinner = true;
    this.tempModifier.preset = this.miscPresetsList.find(item => item.title === this.chosenPreset)?.value

    if (this.tempModifier.id) {
      this.adminPanelService.updateModifier(this.tempModifier).subscribe(res => {
        this.dialogRef.close(res)
      }, () => {
        this.loadingSpinner = false
      })
    } else {
      this.adminPanelService.createModifier(this.tempModifier).subscribe(res => {
        this.dialogRef.close(res)
      }, () => {
        this.loadingSpinner = false
      })
    }
  }


  closeDialog() {
    this.dialogRef.close('close-button');
  }

  deleteSub() {
    this.deleteLoadingSpinner = true
    this.adminPanelService.deleteModifier(this.tempModifier.id).subscribe(() => {

      this.dialogRef.close('delete');
    }, () => {
      this.deleteLoadingSpinner = false
    })
  }

  addNewField() {
    this.tempModifier.fields.push({
      type: 'Input'
    })
  }

  typeValueChanged(field: ModifierField) {
    field.value = ''
  }

}
